import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { navigateTo } from '../../services/router.js';

export interface SubnavTab {
  label: string;
  path: string;
}

@customElement('cp-page-subnav')
export class CpPageSubnav extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) tabs: SubnavTab[] = [];
  @property({ type: String }) activePath = '';

  private _isActive(tabPath: string): boolean {
    return this.activePath === tabPath || this.activePath.startsWith(tabPath + '/');
  }

  private _handleClick(path: string, e: Event): void {
    e.preventDefault();
    navigateTo(path);
  }

  render() {
    return html`
      <nav class="cp-page-subnav">
        ${this.tabs.map(tab => html`
          <a
            class="cp-page-subnav__tab ${this._isActive(tab.path) ? 'cp-page-subnav__tab--active' : ''}"
            href="#${tab.path}"
            @click=${(e: Event) => this._handleClick(tab.path, e)}
          >${tab.label}</a>
        `)}
      </nav>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-subnav': CpPageSubnav;
  }
}
